import Vue, { configureCompat, createApp } from 'vue';
import moment from 'moment-timezone';
import BootstrapVue from 'bootstrap-vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

/* styles */
import '@workflow-solutions/ofs-vue-layout/dist/index.css';
import '@workflow-solutions/siteflow-section-layout/dist/index.css';
import './styles/index.scss';

import siteFlowLayout, {
	FeatureFlags,
	PageService,
	Pusher,
	registerServiceWorker
} from '@workflow-solutions/siteflow-section-layout';

import { store, i18n } from './vuex';
import router, { menuStructure } from './router';
import App from './App';

import { sectionName } from './lib/config';

/**
 * Asynchronous load of the application
 */
(async function run() {
	if (process.env.NODE_ENV === 'production') {
		registerServiceWorker(process.env.BASE_URL, store);
	}

	configureCompat({
		MODE: 2
	});

	FeatureFlags.fetchFeatureFlags();
	PageService.setMeta();
	const routingTables = await siteFlowLayout.sectionsRouting.loadRoutes();

	const app = createApp(App);

	app.config.productionTip = false;
	app.use(BootstrapVue);

	app.use(siteFlowLayout, {
		App,
		moment,
		store,
		router,
		sectionName,
		routingTables,
		menuStructure,
		i18n
	});
	app.use(Pusher);

	// Sentry Error Logging
	// eslint-disable-next-line no-console
	app.config.errorHandler = error => console.error(error);

	Sentry.init({
		dsn: window.$config.sentryDsn,
		environment: window.$config.environment,
		integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
		release: process.env.VERSION,
		ignoreErrors: [
			/^(N|n)etwork\s?(E|e)rror/,
			/^Request failed with status code 40(0|1|3)$/,
			/^Failed to fetch$/,
			/^(C|c)ancelled$/,
			/^ResizeObserver loop/,
			/^Loading chunk .+ failed.$/,
			/^NavigationDuplicated/
		]
	});

	app.use(i18n);
	app.use(store);
	app.use(router);

	router.isReady().then(() => app.mount('#app'));
})();
